<template>
  <div class="d-flex justify-content-around h-100 w-100 mobile-nav-item-container">
    <div
        class="mobile-nav-item"
    >
      <div class="mobile-nav-icon">
        <i class="far fa-list fa-2x"></i>
      </div>
      <div>{{ 'Stage' | trans }}</div>
    </div>

    <div
        class="mobile-nav-item"
    >
      <div class="mobile-nav-icon">
        <i class="far fa-list fa-2x"></i>
      </div>
      <div>{{ 'Tools' | trans }}</div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import GenerateBtn from "../Elements/GenerateBtn.vue";


export default {
  name: 'MobileInpaintingNavbar',
  props: {},
  components: {
    GenerateBtn
  },
  mixins: [store, currentJob],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {},
};
</script>
<style lang="scss">
.main-number {
  font-size: 24px;
  font-weight: bold;
  border: 2px solid white;
  border-radius: 50%;
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;

  &.done {
    border: 2px solid #00C851;
    color: #00C851;
  }
}

.sidebar-item {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 20px;
  border-bottom: 1px solid #595959;
  width: 100%;
  background: #272727;
  color: white;
}

.btn-box {
  min-height: 105px;
  height: 105px;
}

.gap-10 {
  gap: 10px;
}

#sidebar-left {
  width: 400px;
  min-width: 400px;
  background: #383838;
  border-right: 1px solid #595959;

  display: flex;
  flex-direction: column;

  .sidebar-top {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .sidebar-bot {
    background: #272727;
    border-top: 1px solid #595959;
  }
}

#sidebar-left {
  width: 400px;
  min-width: 400px;
  background: white;
  border-right: 1px solid #595959;
  height: 100%;

  .dark-mode & {
    border-right: 1px solid #595959;
    background: #272727;
  }

  display: flex;
  flex-direction: column;

  .sidebar-top {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .sidebar-bot {
    background: #272727;
    border-top: 1px solid #595959;
  }
}
</style>
